import sanityClient from "./sanityClient"; // Adjust the path to your Sanity client

const fetchAboutUs = async () => {
  try {
    const query = `*[_type == "aboutUs"][0]{
      title,
      "image": image.asset->url,
      content,
      boardDescriptionTextbox,
      boardMembers[]->{
        name,
        title,
        businessName,
        "photo": photo.asset->url
      },
      programDescriptionTextbox,
      programMembers[]->{
        name,
        title,
        businessName,
        "photo": photo.asset->url
      }
    }`;

    const data = await sanityClient.fetch(query);

    // Optimize image URLs for speakers' photos
    const optimizedBoardMembers = data.boardMembers.map((member) => ({
      ...member,
      photoUrl: member.photo
        ? `${member.photo}?w=192&h=192&fm=webp&q=100`
        : null,
    }));
    const optimizedProgCommittee = data.programMembers.map((member) => ({
      ...member,
      photoUrl: member.photo
        ? `${member.photo}?w=192&h=192&fm=webp&q=100`
        : null,
    }));

    // Merge back into data
    const optimizedData = {
      ...data,
      imageUrl: data.image ? `${data.image}?w=1200&h=900&fm=webp&q=80` : null,
      boardMembers: optimizedBoardMembers,
      programMembers: optimizedProgCommittee
    };

console.log(optimizedProgCommittee);

    return optimizedData;
  } catch (error) {
    console.error("Error fetching About Us data:", error);
    return null;
  }
};

export default fetchAboutUs;
